// tslint:disable: no-string-literal
import { CurrencyPipe, DecimalPipe, PercentPipe } from '@angular/common';
import { Pipe, PipeTransform, LOCALE_ID, Inject } from '@angular/core';

import { ReduceCopValuePipe } from './reduce-cop-value.pipe';
import { SecondsToTimePipe } from './seconds-to-time.pipe';

@Pipe({ name: 'setValue' })
export class SetValuePipe implements PipeTransform {

  // Se inyecta el LOCALE_ID al constructor siempre que se utilicen pipes de angular
  constructor(@Inject(LOCALE_ID) private locale) { }

  /* transform(): Pipe que formatea un valor a otro por categorías
    value: valor al que se dará formato
    type: categorría
    slice: Cantidad de decimales
  */
  transform(value: string | number | [(...[]) => string | number, ...any[]], type: string, slice = 2): string {
    // ↓ Verifica que el valor no esté vacío
    if (value !== null && value !== undefined) {
      switch (type) {
        // ↓ Formato peso colombiano con separador de miles y "n" decimales
        case 'currency': value = new CurrencyPipe(this.locale).transform(Number(value), "COP", "symbol", `1.0-${slice}`); break;
        // ↓ Formato peso colombiano reducido por cada millon y miles de millones
        case 'big-reduce-currency': value = new ReduceCopValuePipe(this.locale).transform(Number(value), 3); break;
        // ↓ Formato peso colombiano reducido por cada millon y miles de millones
        case 'big-reduce-currency2': value = new ReduceCopValuePipe(this.locale).transform(Number(value), 3, slice); break;
        // ↓ Formato peso colombiano reducido por cada mil
        case 'full-reduce-currency': value = new ReduceCopValuePipe(this.locale).transform(Number(value)); break;
        // ↓ Formato peso colombiano reducido por cada millon
        case 'reduce-currency': value = new ReduceCopValuePipe(this.locale).transform(Number(value), 2); break;
        // ↓ Formato peso colombiano reducido por cada millon
        case 'reduce-currency2': value = new ReduceCopValuePipe(this.locale).transform(Number(value), 2, slice); break;
        // ↓ Formato porcentaje con separador de miles y "n" decimales, multiplica por 100
        case 'percent': value = new PercentPipe(this.locale).transform(Number(value), `1.0-${slice}`); break;
        // ↓ Formato númerico con separador de miles y "n" decimales sin el símbolo
        case 'number': value = new DecimalPipe(this.locale).transform(Number(value), `1.0-${slice}`); break;
        // ↓ Formato númerico con separador de miles y "n" decimales sin el símbolo o N/A
        case 'number-null': value = new DecimalPipe(this.locale).transform(Number(value), `1.0-${slice}`); break;
        // ↓ Formato json cuando el valor es un objeto
        case 'json': value = typeof value === "object" ? JSON.stringify(value) : value; break;
        // ↓ Formato porcentaje con "n" decimales sin el símbolo
        case 'percentage-number': value = Number(Number(value).toFixed(slice)); break;
        // ↓ Formato porcentaje con separador de miles y "n" decimales
        case 'percentage': value = Number(Number(value).toFixed(slice)) + "%"; break;
        // ↓ Formato HH:mm:ss de acuerdo con cantidad de segundos
        case 'time': value = new SecondsToTimePipe().transform(Number(value)); break;
        // ↓ Formato redondeo hacia arriba con 'n' decimales
        case 'ceil': value = Math["ceil10"](Number(value), slice); break;
        // ↓ Formato con callback
        case 'callback':
          // ↓ Verifica si el valor recibido es un objeto y el primer parámetro una función
          if (typeof value === 'object' && typeof value[0] === 'function') {
            // ↓ Asigna el resultado del callback
            value = (value[0](...value.slice(1)) || '');
          } else { value = ''; }
          // ↑ Asigna vació si no cumple con la estructura
          break;
        // ↓ Valor original añadiendo una categorización después
        default: value += ` ${type}`; break;
      }
    } else {
      switch (type) {
        // ↓ Convierte un valor vació a N/A
        case 'number-null': value = "N/A"; break;
      }
    }
    // ↓ Envía el valor formateado
    return value as string;
  }

}
